import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function SectionHeader({ title, color = "#FF6B35", to, linkLabel = "Ver todo", subtitle }) {
  return (
    <div className="flex items-end justify-between mb-6 md:mb-8">
      <div>
        <div className="flex items-center gap-3">
          <span className="w-1.5 h-7 rounded-sm" style={{ backgroundColor: color }} />
          <h2 className="font-serif font-black text-2xl md:text-3xl text-nx-dark tracking-tight">{title}</h2>
        </div>
        {subtitle && <p className="mt-1.5 ml-4.5 text-sm text-gray-500">{subtitle}</p>}
      </div>
      {to && (
        <Link to={to} data-testid={`section-link-${title.toLowerCase().replace(/\s+/g, "-")}`}
          className="hidden sm:inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-gray-500 hover:text-nx-orange transition-colors whitespace-nowrap">
          {linkLabel} <ArrowRight size={14} />
        </Link>
      )}
    </div>
  );
}
